/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  MutationKey,
  useMutation,
  UseMutationResult,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { killswitchesCreate } from "../funcs/killswitchesCreate.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { KillswitchMutationReceipt } from "../models/components/killswitchmutationreceipt.js";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { KillswitchConflict } from "../models/errors/killswitchconflict.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  KillswitchesCreateRequest,
  KillswitchesCreateSecurity,
} from "../models/operations/killswitchescreate.js";
import { unwrapAsync } from "../types/fp.js";
import { useGramContext } from "./_context.js";
import { MutationHookOptions } from "./_types.js";

export type CreateKillswitchMutationVariables = {
  security: KillswitchesCreateSecurity;
  request: KillswitchesCreateRequest;
  options?: RequestOptions;
};

export type CreateKillswitchMutationData = KillswitchMutationReceipt;

export type CreateKillswitchMutationError =
  | KillswitchConflict
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * create killswitches
 */
export function useCreateKillswitchMutation(
  options?: MutationHookOptions<
    CreateKillswitchMutationData,
    CreateKillswitchMutationError,
    CreateKillswitchMutationVariables
  >,
): UseMutationResult<
  CreateKillswitchMutationData,
  CreateKillswitchMutationError,
  CreateKillswitchMutationVariables
> {
  const client = useGramContext();
  return useMutation({
    ...buildCreateKillswitchMutation(client, options),
    ...options,
  });
}

export function mutationKeyCreateKillswitch(): MutationKey {
  return ["@gram/client", "killswitches", "create"];
}

export function buildCreateKillswitchMutation(
  client$: GramCore,
  hookOptions?: RequestOptions,
): {
  mutationKey: MutationKey;
  mutationFn: (
    variables: CreateKillswitchMutationVariables,
  ) => Promise<CreateKillswitchMutationData>;
} {
  return {
    mutationKey: mutationKeyCreateKillswitch(),
    mutationFn: function createKillswitchMutationFn({
      security,
      request,
      options,
    }): Promise<CreateKillswitchMutationData> {
      const mergedOptions = {
        ...hookOptions,
        ...options,
        fetchOptions: {
          ...hookOptions?.fetchOptions,
          ...options?.fetchOptions,
          signal: combineSignals(
            hookOptions?.fetchOptions?.signal,
            options?.fetchOptions?.signal,
          ),
        },
      };
      return unwrapAsync(killswitchesCreate(
        client$,
        security,
        request,
        mergedOptions,
      ));
    },
  };
}
